import React, { Component } from "react";
import PdfIcon from '../../../../../../src/img/pdf-icon.png';
import MsgIcon from "../../../../../../src/img/msg-icon2.png";
import XlsIcon from "../../../../../../src/img/exportExcel.png";
import FileIcon from "../../../../../../src/img/icn_export.png";
import DocIcon from "../../../../../../src/img/docx-icon.png";
import Translation from "../../../common/translation/translation.component";

export class OrderRequestFiles extends Component {

    setIcon = (filename) => {
        var getExtension = (filename.substr(filename.length - 4).toLowerCase()).toString();
        var icon;

        switch (getExtension) {
            case ".pdf":
                icon = PdfIcon;
                break;
            case ".msg":
                icon = MsgIcon;
                break;
            case "docx":
                icon = DocIcon;
                break;
            case ".xls":
            case "xlsx":
                icon = XlsIcon;
                break;
            default:
                icon = FileIcon;
        };

        return (
            <div className="file-uploaded" key={filename}>
                <img src={icon} alt={icon} className="file-icon" />
                <div className="file-name-cont"
                    data-toggle="tooltip"
                    title={filename}>
                    <span className="file-name">
                        {filename}
                    </span>
                </div>
            </div>
        )
    }

    render() {
        const { files } = this.props;

        return (
            <div>
                <h5 className="order-detail-location-title"> <Translation translationKey="files_uploaded" /> </h5>
                {files !== null && files.length > 0?
                    files.map((file) => {
                        return (
                            this.setIcon(file)
                        )
                    }) :
                    <div className="no-file"> <Translation translationKey="no_files_uploaded" /> </div>
                }
            </div>
        )
    }
}